//import { useMyContext } from "../MyProvider";
//import Navbar from "../Navbar";

//import { useMyContext } from "js/MyProvider";

import { useMyContext } from "../compents/MyProvider";

const LoginSuccess = () => {
    const lang = 1
    const {data} = useMyContext();

    return(
        <div id="wrapper">
            {/* <Navbar lang={lang} role={data}/> */}
            {/* <LoginMenu/> */}
            <div className="wrapper row3">
                <div id="container">
                    <br /><br />
                    <div align="center">
                        <br /><br /><br />
                        <div align="center">
                            <img src="/images/login.png" alt="login success"  />
                        </div>
                        <div id="content-container" align="center" style={{height:"24px"}}>
                            <h2 style={{fontWeight:"Ariel"}}>Login Successful</h2>
                        </div>
                        <br></br>
                        <div className="mainhead" align="center">
                            Welcome to ePos Management System
                        </div>
                    </div>
                    <br /><br /><br />
                </div>
            </div>

        </div>
    )

}

export default LoginSuccess;